// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"b1658367","155":"b1658367","493":"b1658367","506":"b1658367","552":"b1658367","716":"2ae86483"}[chunkId] + ".chunk.css";
};